export const enum SlideType {
  AI_DECIDED = 'ai',
  Text = 'text',
  BulletPoints = 'bullet-points',
}
